import { render } from "./ProgressIndicatorThreeDots.vue?vue&type=template&id=562bcb93&scoped=true"
const script = {}

import "./ProgressIndicatorThreeDots.vue?vue&type=style&index=0&id=562bcb93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562bcb93"]])

export default __exports__